import { render, staticRenderFns } from "./BuildingStaffImport.vue?vue&type=template&id=cc12126e&"
import script from "./BuildingStaffImport.vue?vue&type=script&lang=ts&"
export * from "./BuildingStaffImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc12126e')) {
      api.createRecord('cc12126e', component.options)
    } else {
      api.reload('cc12126e', component.options)
    }
    module.hot.accept("./BuildingStaffImport.vue?vue&type=template&id=cc12126e&", function () {
      api.rerender('cc12126e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingStaffImport.vue"
export default component.exports